import {GET_CrystalPdf} from '../constants/ActionTypes'

const INIT_STATE = {
    CrystalPdf: null,
    loading: false
};

export default (state = INIT_STATE, action) => {

    switch (action.type) {
        case GET_CrystalPdf:
            return {
                CrystalPdf: action.body,
                loading :false
            }
        default:
            return state;
    }
}